<template>
  <div class="top-menu">
    <p
      class=""
      v-bind:class="{ active: activeSection == index }"
      v-on:click="scrollToSection(index, false, 'head')"
      v-for="(mnName, index) in menu"
      v-bind:key="index"
      v-title="'Go to section ' + (index + 1)"
    >
      {{ mnName }}
    </p>
  </div>

  <div class="sections-menu">
    <p
      class="menu-point"
      v-bind:class="{ active: activeSection == index }"
      v-on:click="scrollToSection(index, false, 'side')"
      v-for="(offset, index) in offsets"
      v-bind:key="index"
      v-title="'Go to section ' + (index + 1)"
    ></p>
  </div>

  <section class="fullpage section section1">
    <mainContent />
  </section>
  <section class="fullpage section section2">
    <companyIntro />
  </section>
  <section
    v-for="(comp, index) in this.companySeqList"
    :key="index"
    class="fullpage section section3"
  >
    <div class="container">
      <ProductIntro :id="comp" :companyLabel="this.companyNameList[index] ? this.companyNameList[index] : ''"/>
    </div>
  </section>
<!--  <section class="fullpage section section6" id="contact">-->
<!--    <ContactUs-->
<!--      :inMove="this.inMove"-->
<!--      @onChangeModalState="this.handledModalState"-->
<!--    />-->
<!--  </section>-->
  <section class="fullpage section section7" id="footer">
    <pageFooter />
  </section>
</template>

<script>
import mainContent from "@/components/mainContent.vue";
import companyIntro from "@/components/companyIntro.vue";
// import ContactUs from "@/components/ContactUs.vue";
import ProductIntro from "@/components/productIntro.vue";
import pageFooter from "@/components/pageFooter.vue";
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import fullpage from "fullpage.js";

// url 공통화
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});
export default {
  components: {
    // ContactUs,
    ProductIntro,
    mainContent,
    companyIntro,
    pageFooter,
  },
  data() {
    return {
      companySeqList: [],
      companyNameList: [],
      inMove: false,
      inMoveDelay: 700,
      activeSection: 0,
      offsets: [],
      touchStartY: 0,
      // menu: ["HOME", "회사소개", "제품소개", "Contact"],
      menu: ["HOME", "회사소개", "제품소개"],
      swiperOptions: {
        // Swiper 옵션을 설정합니다.
        slidesPerView: 3,
        spaceBetween: 30,
        // 기타 옵션들...
      },
      isModal: false,
    };
  },
  methods: {
    handledModalState(state) {
      /* modal emit function */
      if (state) {
        //modalState : Open
        this.handledMouseWheelSetting(true);
        document.body.style.overflow = "hidden"; //css background wheel over X
      } else {
        //modalState : Close
        this.handledMouseWheelSetting(false);
        document.body.style.overflow = "auto"; //css background wheel over O
      }
    },
    /* 핸들러 이벤트리스너 적용 false - 적용 , true - 해제 */
    handledMouseWheelSetting(payload) {
      if (payload) {
        window.removeEventListener("DOMMouseScroll", this.handleMouseWheelDOM); // Mozilla Firefox
        window.removeEventListener("wheel", this.handleMouseWheel, {
          passive: false,
        }); // Other browsers

        window.removeEventListener("touchstart", this.touchStart); // mobile devices
        window.removeEventListener("touchmove", this.touchMove); // mobile devices
      } else {
        window.addEventListener("DOMMouseScroll", this.handleMouseWheelDOM); // Mozilla Firefox
        window.addEventListener("wheel", this.handleMouseWheel, {
          passive: false,
        }); // Other browsers

        window.addEventListener("touchstart", this.touchStart, {
          passive: true,
        }); // mobile devices
        window.addEventListener("touchmove", this.touchMove, {
          passive: false,
        }); // mobile devices
        window.addEventListener("touchend", this.touchEnd, {
          passive: true,
        }); // mobile devices
      }
    },
    calculateSectionOffsets() {
      let sections = document.getElementsByTagName("section");
      let length = sections.length;
      console.log("SectionCounnt >> " + length);
      this.offsets = [];
      for (let i = 0; i < length; i++) {
        let sectionOffset = sections[i].offsetTop;
        this.offsets.push(sectionOffset);
      }
    },
    /**
     * Handle the 'mousewheel' event for other browsers
     */
    handleMouseWheel: function (e) {
      if (e.wheelDelta < 0 && !this.inMove) {
        this.moveUp();
      } else if (e.wheelDelta > 0 && !this.inMove) {
        this.moveDown();
      }

      this.$emit("scroll-event", this.inMove);

      e.preventDefault();
      return false;
    },
    /**
     * Handle the 'DOMMouseScroll' event for Firefox
     */
    handleMouseWheelDOM: function (e) {
      if (e.detail > 0 && !this.inMove) {
        this.moveUp();
      } else if (e.detail < 0 && !this.inMove) {
        this.moveDown();
      }

      return false;
    },
    /**
     * Move to the previous section or the last section if you're on the first section
     */
    moveDown() {
      this.inMove = true;
      this.activeSection--;

      //최하단일경우 최상단으로 이동
      /*if (this.activeSection < 0) this.activeSection = this.offsets.length - 1;*/

      //최하단일경우 정지
      if (this.activeSection < 0) this.activeSection = 0;

      this.scrollToSection(this.activeSection, true);

      if (this.activeSection == 1) {
        console.log("88888");
      }
    },
    /**
     * Move to the next section or the first section if you're on the last section
     */
    moveUp() {
      this.inMove = true;
      this.activeSection++;

      //최상단일경우 최하단으로 이동
      /*if (this.activeSection > this.offsets.length - 1) this.activeSection = 0;*/

      //최상단일경우 이동 정지
      if (this.activeSection > this.offsets.length - 1)
        this.activeSection = this.offsets.length - 1;

      this.scrollToSection(this.activeSection, true);
    },
    /**
     * Scrolls to the passed section id if the section exists and the delay is over
     */
    scrollToSection(id, force = false, type = "") {
      if (this.inMove && !force) return false;
      if (id == 3 && type == "head") {
        id = document.getElementsByClassName("menu-point").length - 2;
      }
      this.activeSection = id;
      this.inMove = true;

      // get section and scroll into view if it exists
      let section = document.getElementsByTagName("section")[id];
      let sectionTarget = document.getElementsByTagName("section")[id];
      if (section) {
        sectionTarget.scrollIntoView({ behavior: "smooth" });
      }
      setTimeout(() => {
        this.inMove = false;
      }, this.inMoveDelay);

      const menuPoint = document.getElementsByClassName("menu-point");

      const classLists = menuPoint.length;
      if (classLists > 0) {
        const lastClass = menuPoint[classLists - 2];
        lastClass.classList.remove("active");
      }
    },
    /**
     * Handles the 'touchstart' event on mobile devices
     */
    touchStart(e) {
      if (this.inMove) return false;
      e.preventDefault();
      this.touchStartY = e.touches[0].clientY;
    },
    /**
     * Handles the 'touchmove' event on mobile devices
     */
    touchMove(e) {
      if (this.inMove) return false;
      e.preventDefault();

      const currentY = e.touches[0].clientY;

      if (this.touchStartY < currentY) {
        this.moveDown();
      } else if(this.touchStartY > currentY){
        this.moveUp();
      }

      this.touchStartY = 0;
      return false;
    },
    /**
     * Handles the 'touchmove' event on mobile devices
     */
    touchEnd(e) {
      e.preventDefault();
      this.inMove = false;
    },
    getCompanyList() {
      instance
        .get(`/api/tech/v1.0/company/listAll`, {
          headers: {
            "x-api-key": `${process.env.VUE_APP_API_KEY || "YsD4oLqC2MgBzP1x"}`, // 여기에 API 키 값을 넣어주세요
          },
        })
        .then((res) => {
          if (res.data.code === "200") {
            const result = res.data.results;
            /* 섹션 동적 생성을 위한 company 세팅 */
            result.forEach((company) => {
              if (company.companySeq && company.items.length > 0)
                this.companySeqList.push(company.companySeq);
                this.companyNameList.push(company.companyName);
            });
          }
          //동적렌더링 체크
          this.$nextTick(() => {
            console.log("동적으로 생성된 HTML이 렌더링되었습니다.");
            this.calculateSectionOffsets();
          });
        })
        .catch((error) => {
          if (error.response) {
            // 요청은 성공했지만 서버가 2xx 이외의 상태 코드로 응답한 경우.
            console.log("서버 응답 상태 코드:", error.response.status);
            console.log("응답 데이터:", error.response.data); // 응답 데이터에서 오류 세부 정보 확인
          } else if (error.request) {
            // 요청은 성공했지만 응답을 받지 못한 경우.
            console.log("서버로부터 응답을 받지 못했습니다.");
          } else {
            // 요청 설정 중 오류가 발생한 경우.
            console.log("오류:", error.message);
          }
        });
    },
  },
  created() {
    this.getCompanyList();
  },
  /**
   * mounted() hook executes after page load and call the section offset calculation and registers all events
   */
  mounted() {
    //Y축 휠 숨김처리
    document.body.style.overflowY = "hidden";
    this.handledMouseWheelSetting(false); //휠 세팅 on
  },
  unmounted() {
    this.handledMouseWheelSetting(true); //휠 세팅 off
  },
};
</script>
